<template>
    <div class="columns">
        <div class="column is-12-mobile is-10-desktop is-10-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Report Review <span v-if="is_loading" class="button is-white has-text-right preloader" :class="{'is-loading': is_loading}"></span></div>
                </div>
            </div>
            <div v-if="!is_loading">
                <div class="level">
                    <div class="level-left">
                        <h6 class="subtitle is-6 has-text-weight-bold">Complete the form below to report this review.</h6>
                    </div>
                </div>
                <div class="level">
                    <div class="level-left">
                        <form novalidate @submit.prevent="submitForm">
                            <h6 class="subtitle is-6">What is your reason for reporting this review?</h6>
                            <div class="" v-for="reason in reasons">
                                <label class="radio is-size-6 level margin-bottom-10">
                                    <span>
                                        <input
                                                type="radio"
                                                :value="reason.id"
                                                v-model="review_reason"
                                                name="reason"/>&nbsp;{{reason.reason}}
                                    </span>
                                </label>
                            </div>
                            <h6 class="subtitle is-6 margin-top-20">Why should this review be removed? <span class="is-size-7">(max 245 char)</span></h6>
                            <div class="level">
                                <textarea class="textarea" v-model="report_reason" cols="50" maxlength="245"></textarea>
                            </div>

                            <!--save button-->
                            <div class="buttons is-pulled-right is-fullwidth">
                                <button
                                        type="reset"
                                        @click="cancel"
                                        :class="[{'is-loading': is_posting}, 'button is-button-blue-outline']" >CANCEL</button>

                                <button
                                        type="submit"
                                        :disabled="enabledButton"
                                        :class="{'is-loading': is_posting}"
                                        class="button is-button-blue">REPORT REVIEW</button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import ApiResource from '../../api/ApiResource'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Report Review'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Report Review'
      })
    },
    props: ['permalink'],
    data () {
      return {
        review_reason: '',
        report_reason: '',
        is_loading: false,
        reasons: [],
        form_has_changed: false,
        is_posting: false,
        form: new ApiResource({})
      }
    },
    computed: {
      enabledButton () {
        return (!this.form_has_changed || this.is_sending)
      }
    },
    watch: {
      review_reason () {
        if (this.review_reason === '') {
          this.form_has_changed = false
        }
        if (this.review_reason !== '' && this.report_reason !== '') {
          this.form_has_changed = true
        }
      },
      report_reason () {
        if (this.report_reason === '') {
          this.form_has_changed = false
        }
        if (this.report_reason !== '' && this.review_reason !== '') {
          this.form_has_changed = true
        }
      }
    },
    created () {
      this.getReportReasons()
    },
    methods: {
      /**
       * Get list of report reasons from the api
       * @returns {null}
       */
      getReportReasons () {
        this.is_loading = true
        let parent = this
        new ApiResource({}).send('report-reasons', {}, 'get')
            .then((response) => {
          response.forEach(function (reason) {
            parent.reasons.push(reason)
          })
          this.is_loading = false
        })
      },
      /**
       * Makes an api call to report a review.
       * @returns {void}
       */
      submitForm () {
        this.is_posting = true
        this.form.send(`/report-review/${this.permalink}`, {report_reason: this.report_reason, review_reason: this.review_reason})
          .then(() => {
              flash('You have successfully reported this review.')
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'success',
                      'messageName': 'Successfully reported review on Report Review View',
                      'displayedMessage': 'You have successfully reported this review.'
                  }
              })
          })
          .catch(() => {
              const errMsg = this.form.errors.getDefaultErrorMessage()
              flash(errMsg, 'is-danger')
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'error',
                      'messageName': 'Failed to report review on Report Review View',
                      'displayedMessage': errMsg
                  }
              })
          })
        this.is_posting = false
        this.review_reason = ''
        this.report_reason = ''
        this.form_has_changed = false
        this.cancel()
      },
      /**
       * Redirect page to the review details page.
       * @returns {void}
       */
      cancel () {
        this.$router.push('/review/' + this.permalink)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/reviews/ReportReview.vue